import {NgModule} from '@angular/core';
import {ValidationMessageComponent} from './components/validation/validation-message.component';
import {ComponentSetupService} from './component-setup.service';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {FormbirdServicesModule} from 'formbird-services';
import { MatAutocompleteModule} from '@angular/material/autocomplete';

@NgModule({
  declarations: [ValidationMessageComponent ],
  imports: [CommonModule, MatIconModule, FormbirdServicesModule, MatAutocompleteModule ],
  exports: [ValidationMessageComponent ],
  providers: [ComponentSetupService],
})
export class FormbirdScSharedModule {
}
